import React from 'react';
import PropTypes from 'prop-types';
import SubmissionFooter from 'screens/Integrations/components/SubmissionFooter';
import { CalAgContext } from '../../context/Provider';

const calAgSubmissionFooterDefaultPropOnNext = () => {};
const calAgSubmissionFooterDefaultPropSetModalSubmissionState = () => {};
const CalAgSubmissionFooter = ({
  nextDisabled = false,
  nextLabel = 'Next',
  onNext = calAgSubmissionFooterDefaultPropOnNext,
  loading = false,
  setModalSubmissionState = calAgSubmissionFooterDefaultPropSetModalSubmissionState,
  isLastStep = false,
  displaySubmissionModal = true
}) => {
  return (
    <SubmissionFooter
      nextDisabled={nextDisabled}
      onNext={onNext}
      nextLabel={nextLabel}
      loading={loading}
      setModalSubmissionState={setModalSubmissionState}
      isLastStep={isLastStep}
      context={CalAgContext}
      displaySubmissionModal={displaySubmissionModal}
      integrationType="CalAgPermits"
    />
  );
};

CalAgSubmissionFooter.propTypes = {
  nextDisabled: PropTypes.bool,
  nextLabel: PropTypes.string,
  loading: PropTypes.bool,
  onNext: PropTypes.func,
  setModalSubmissionState: PropTypes.func,
  isLastStep: PropTypes.bool,
  displaySubmissionModal: PropTypes.bool
};

export default CalAgSubmissionFooter;
